/**
 * @generated SignedSource<<cd20e8ac36d7d399f808bc3c4fb89fde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutFooter_viewer$data = {
  readonly merchantAccounts: ReadonlyArray<{
    readonly countryName: string | null;
    readonly currency: string | null;
  } | null> | null;
  readonly stripeIsEnabled: boolean | null;
  readonly " $fragmentType": "CheckoutFooter_viewer";
};
export type CheckoutFooter_viewer$key = {
  readonly " $data"?: CheckoutFooter_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFooter_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutFooter_viewer",
  "selections": [
    {
      "alias": "stripeIsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "stripeCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"stripeCheckout\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "accountType",
          "value": "TRANSACTION"
        }
      ],
      "concreteType": "MerchantAccount",
      "kind": "LinkedField",
      "name": "merchantAccounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": "merchantAccounts(accountType:\"TRANSACTION\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "020aac40e57db8d164a34054c516e35d";

export default node;
